import { useQuery } from "@tanstack/react-query"
import apiRoutes from "../apiRoutes"
import api from "../utils"

export const useCountries = () => {
    const getCountries = async () => {
        const res = await api.get(apiRoutes.countries)
        return res.data
    }

    const { data: countries, ...rest } = useQuery<Countries>({
        queryKey: ['country_list'],
        queryFn: getCountries
    })

    return {
        countries,
        ...rest
    }
}